import TablePaste from './table-paste.vue';
export default TablePaste;


// WEBPACK FOOTER //
// ./src/components/table-paste/index.js